import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Grid, Divider, Typography, Button, ThemeProvider, Hidden, Paper } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { StickyFooter } from "../../../panel";
import { addRegisteredLayout } from "../layoutDescriptions";
import { Panel } from "../../../panel";
import { DirwebStepper } from "./DirwebStepper";
import { useStyles, actionsTheme, mainTheme } from "./styles";
import { usePageState } from "../../../PageContext";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { useTenant } from "@ploy-ui/tenants";
const mainPanelSettings = {
    editableOptions: {
        title: false,
        elevation: true,
        square: true
    }
};
const panelSettings = {
    main: mainPanelSettings,
    actions: {},
    stickyFooter: mainPanelSettings,
    stickyFooterExpanded: mainPanelSettings
};
addRegisteredLayout({
    name: "Dirweb",
    displayName: "Dirweb",
    panels: panelSettings,
    pageDescription: true
});
export const Dirweb = (props) => {
    const { description, panels, stepper } = props;
    const { main, actions, stickyFooter, stickyFooterExpanded } = panels;
    const { step, prev } = usePageState();
    const footerRef = useRef(null);
    const [footerHeight, setFooterHeight] = useState(70);
    const updateFooterHeight = () => {
        if (footerRef?.current) {
            // Is zero if footer is hidden. Typically when loading form
            if (footerRef.current.clientHeight === 0) {
                setTimeout(() => updateFooterHeight(), 500);
                return;
            }
            const newHeight = footerRef.current.clientHeight < 70
                ? 70
                : footerRef.current.clientHeight;
            if (footerHeight !== newHeight)
                setFooterHeight(newHeight);
        }
    };
    useEffect(() => {
        updateFooterHeight();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const tenantConfig = useTenant();
    const dirWebPaddingTop = tenantConfig?.tenant?.settings?.dirWebPaddingTop;
    const stylesProps = {
        stickyFooterHeight: footerHeight,
        dirWebPaddingTop: dirWebPaddingTop
    };
    const dirwebClasses = useStyles(stylesProps);
    const myActions = {
        ...actions,
        sections: [
            {
                formTemplateSectionId: "__myaction",
                fields: actions?.sections?.[0]?.fields?.filter(f => f.role !== "navigate_before") ?? []
            }
        ]
    };
    let leftComponent = null;
    if (step > 0 || props.pageTitle || description)
        leftComponent = (_jsxs(_Fragment, { children: [_jsxs(Grid, { item: true, xs: 12, md: 3, children: [step > 0 && (_jsx(Button, { className: dirwebClasses.backLink, color: "primary", variant: "text", onClick: prev, startIcon: _jsx(ArrowBack, {}), children: _jsx(FormattedMessage, { id: "dirweb.step-summary.navigate-back-button", defaultMessage: "Forrige steg" }) })), props.pageTitle && (_jsx(Typography, { variant: "h5", gutterBottom: true, className: dirwebClasses.titleText, children: props.pageTitle })), _jsx(Hidden, { smDown: true, children: _jsx(Typography, { color: "textSecondary", variant: "subtitle2", children: description }) })] }), _jsx(Grid, { item: true, component: Hidden, smDown: true, implementation: "css", children: _jsx(Divider, { orientation: "vertical" }) })] }));
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, className: clsx(dirwebClasses.root), justifyContent: "center", children: [!stepper && (_jsx(Grid, { item: true, xs: 12, md: 8, children: _jsx(DirwebStepper, { step: step }) })), main && (_jsx(Grid, { component: Paper, item: true, xs: 12, md: 8, className: clsx(dirwebClasses.mainGrid), children: _jsxs(Grid, { container: true, spacing: 2, alignItems: "stretch", children: [leftComponent, _jsxs(Grid, { item: true, xs: 12, md: true, children: [_jsx(ThemeProvider, { theme: mainTheme, children: _jsx(Panel, { ...main, transparent: true, disableTabs: true }) }), _jsx(ThemeProvider, { theme: actionsTheme, children: _jsx(Panel, { ...myActions, transparent: true, disableTabs: true }) })] })] }) }))] }), _jsx(StickyFooter, { innerRef: footerRef, stickyFooter: stickyFooter, stickyFooterExpanded: stickyFooterExpanded })] }));
};
Dirweb.displayName = "DployFormDirweb";
//# sourceMappingURL=Dirweb.js.map